/**
 * Done-line for the background research toast.
 * IG / SEO must not fall through to the DM-finder "emails found" copy.
 */
export function bulkResearchDoneLog({
  running,
  results = [],
  total = 0,
  totalEmails = 0,
  elapsedLabel = '0s',
  lastLogText = '',
} = {}) {
  if (running === 'funnel') {
    return lastLogText || `Funnel finished in ${elapsedLabel}`;
  }
  if (running === 'seo') {
    const ok = results.filter((r) => r.status === 'success').length;
    return `${ok}/${total} scans completed in ${elapsedLabel}`;
  }
  if (running === 'reviews') {
    const ok = results.filter((r) => r.status === 'success').length;
    const left = total - results.length;
    return `${ok}/${total} review audits in ${elapsedLabel}${left > 0 ? ` · ${left} not processed` : ''}`;
  }
  if (running === 'connector') {
    const withData = results.filter((r) => r.status === 'success' && r.total > 0).length;
    const empty = results.filter((r) => r.status === 'success' && !r.total).length;
    const left = total - results.length;
    return `${withData}/${total} contacts enriched in ${elapsedLabel}${empty ? ` · ${empty} nothing found` : ''}${left > 0 ? ` · ${left} not processed` : ''}`;
  }
  if (running === 'instagram') {
    const ok = results.filter((r) => r.status === 'success').length;
    return `${ok}/${total} profiles researched in ${elapsedLabel}`;
  }
  return `${totalEmails} email${totalEmails !== 1 ? 's' : ''} found in ${elapsedLabel}`;
}
